//export const API_ROOT = `http://192.168.41.129:8080/`;
//export const API_ROOT = `https://banca-esportiva.staging.apispt.net/`;
export const API_ROOT = process.env.VUE_APP_API_URL;